// @flow
//
export type ConsentStatus = 'granted' | 'denied';

type Window = {
  dataLayer: Array<any>,
  location: Location,
  document: Document,
  // Add other window properties you use
  [key: string]: any,
};

export function initGtm(gtmId: string) {
  window.dataLayer = window.dataLayer || [];
  const isGtmLoaded = window.dataLayer.some(
    (item: any) => item && typeof item === 'object' && item['gtm.start'],
  );

  if (isGtmLoaded) return;

  function gtag(...args: Array<any>) {
    window.dataLayer.push(args);
  }

  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  });

  // GTM script injection
  (function (w: Window, d: any, s: any, l: string, i: string) {
    // The following line is not a real reassign. But an init to empty Array.
    // eslint-disable-next-line no-param-reassign
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}`;
    if (f?.parentNode) f.parentNode.insertBefore(j, f);
    else d.head?.appendChild(j);
  })(window, document, 'script', 'dataLayer', gtmId);
}

export function updateGoogleConsent(status: ConsentStatus) {
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: Array<any>) {
    window.dataLayer.push(args);
  }
  gtag('consent', 'update', {
    ad_storage: status,
    ad_user_data: status,
    ad_personalization: status,
    analytics_storage: status,
  });
}
